export const SITE_SEO_KEYS = {
  title: 'site.seo.title',
  description: 'site.seo.description',
  keywords: 'site.seo.keywords',
}

const RAW_SEO_KEY_RE = /^[A-Za-z][\w-]*(?:\.[A-Za-z][\w-]*)+$/

export function looksLikeRawSeoKey(value, key) {
  if (typeof value !== 'string') return false
  const text = value.trim()
  if (!text) return false
  if (key && text === key) return true
  return RAW_SEO_KEY_RE.test(text) && (
    text.includes('.meta.') ||
    text.includes('.seo.') ||
    /\.(?:title|desc|description|keywords)$/.test(text)
  )
}

function normalizeSeoText(value, key) {
  if (typeof value !== 'string') return null
  const text = value.trim()
  if (!text || looksLikeRawSeoKey(text, key)) return null
  return text
}

/**
 * SEO 文案优先用 `tm` 取原始字符串，避免 `t()` 将 `|` 解析为复数分隔符而截断 title。
 */
export function resolveSeoText(t, te, tm, key, fallbackKey) {
  const pick = (k) => {
    if (!k || !te(k)) return null
    const raw = tm(k)
    return normalizeSeoText(raw, k) ?? normalizeSeoText(t(k), k)
  }

  return pick(key) ?? pick(fallbackKey) ?? ''
}
